import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b10c601")

_pushScopeId("data-v-1b10c601")
const _hoisted_1 = { class: "content-width" }
const _hoisted_2 = { class: "plane-content flex flex--valign-c flex--halign-c flex--gap-20 flex--wrap" }
const _hoisted_3 = { class: "text text--accent-gray-b text--medium text--center" }
const _hoisted_4 = { class: "version" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavigationLink = _resolveComponent("NavigationLink")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Plane, {
        class: "plane plane--offset",
        rounded: true,
        "rounded-bottom": false
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
              return (_openBlock(), _createBlock(_component_NavigationLink, {
                key: route.title,
                "href-route": route.hrefRoute,
                href: route.href,
                "page-route": route.pageRoute,
                title: route.title,
                "not-a-link": route.notALink,
                uppercase: true
              }, null, 8, ["href-route", "href", "page-route", "title", "not-a-link"]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Plane, {
        class: "plane plane--no-padding",
        rounded: true,
        "rounded-bottom": false,
        darker: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.$trans("footer.copyright")) + " ", 1),
            _createVNode("span", _hoisted_4, "· v" + _toDisplayString(_ctx.$page.props.appVersion), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
})